/**
 * /dashboard/accounting/sales/quotes/new — Create quote (G_ACC5).
 *
 * Quotes have no journal effect; Save & Send is a pure state-machine
 * flip via POST /quotes/{id}/transition with to: 'sent'.
 *
 * Migration note (Phase 3e — 2026-06-01): port of
 * frontend/src/app/(dashboard)/dashboard/accounting/sales/quotes/new/page.tsx.
 */

import { createFileRoute } from "@tanstack/react-router";
import { AccountingModuleShell } from "@/components/shared/accounting-module-shell";
import { QuoteForm } from "@/components/accounting/quote-form";

export const Route = createFileRoute(
  "/_authgated/app/$tenantSlug/accounting/sales/quotes/new",
)({
  component: NewQuoteRoute,
});

function NewQuoteRoute() {
  // Top-of-page Back button removed per Audit 4 Quick-Win #4 — the
  // bottom Cancel handles it.
  return (
    <AccountingModuleShell
      title="New quote"
      description="Create a draft and share when ready."
    >
      <QuoteForm />
    </AccountingModuleShell>
  );
}
